import cn from 'classnames';
import { useRefreshContributions } from 'hooks/api/contributions';
import { RefreshIcon_24 } from 'assets/icons';
import Button from 'components/Button/Button';

import styles from './RefreshContributions.module.css';
import messages from './RefreshContributions.messages';

const RefreshContributions = (): JSX.Element => {
  const { mutateAsync: refreshContributions, isLoading } = useRefreshContributions();

  return (
    <Button
      variant={'outline'}
      className={cn(styles.button)}
      onClick={() => {
        refreshContributions();
      }}
      isLoading={isLoading}
    >
      <RefreshIcon_24 className={cn(styles.icon)} />
      {messages.refresh}
    </Button>
  );
};

export default RefreshContributions;
